import { Component, OnInit } from '@angular/core';
import { BillingControlService } from '../service/billing-control.service';

@Component({
  selector: 'app-bc-expired-1-x',
  templateUrl: './bc-expired-1-x.component.html',
  styleUrls: ['./bc-expired-1-x.component.scss']
})
export class BcExpired110Component implements OnInit {

  private BcRecentData = [];
  private BcRecentTotal = 0;

  //Chart Configuration and Data
  hasLegend = 'true'
  chartType = 'pie'
  private chartData = [
    {
      data: []
    }
  ];
  private chartLabels = [];
  private showChart = false;
  private isLoaded = false;
  private showAll = false;

  constructor(private billingControlService: BillingControlService) {
  }

  ngOnInit() {
  }

  onOpenAccordion() {
    if (this.isLoaded == false) {
      this.getBCRecent();
    }
  }

  getBCRecent() {
    this.billingControlService.getBCRecent(this.showAll).subscribe(result => {
      if (result.Success) {
        this.BcRecentData = result.Result || [];
        this.BcRecentTotal = result.Total;
        this.isLoaded = true;
        this.defineChartByData();
      } else {
        console.log("Erro ao carregar dados!");
      }
    }, error => {
      console.log(error);
    });
  }

  defineChartByData() {
    if (this.BcRecentData.length > 1) {
      this.BcRecentData.forEach((row, index) => {
        this.addChartData(row.Nome, row.Percentual);
        if (index == this.BcRecentData.length - 1) {
          this.showChart = true;
        }
      });
    }
  }

  addChartData(label, data) {
    const tempChartData = this.chartData[0].data;
    tempChartData.push(data);
    this.chartData[0].data = tempChartData;
    this.chartLabels.push(label);
  }

  onShowAll() {
    this.showAll = true;
    this.getBCRecent();
  }

  onShowLess() {
    this.showAll = false;
    this.getBCRecent();
  }
}



// WEBPACK FOOTER //
// ./src/app/billing-control/billing-control/bc-expired-1-x/bc-expired-1-x.component.ts